<template lang="html">
  <expanding>
    <div v-show="expanded">
      <slot/>
    </div>
  </expanding>
</template>

<script>
import Expanding from 'vue-bulma-expanding'

export default {
  components: {
    Expanding
  },

  data(){
    return this.$parent._data
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/panel/Expander.vue